import type { Comment } from '@/types/comment';

/** Окно «1 минута после создания» для удаления своего комментария. */
export const OWN_COMMENT_DELETE_WINDOW_MS = 60_000;

export function canAuthorDeleteOwnComment(
  comment: Pick<Comment, 'createdAt' | 'childrenCount'>,
  options?: { nowMs?: number; repliesCount?: number },
): boolean {
  const repliesCount = options?.repliesCount ?? comment.childrenCount?.totalDocs ?? 0;
  if (repliesCount > 0) {
    return false;
  }

  const createdAtMs = new Date(comment.createdAt).getTime();
  if (!Number.isFinite(createdAtMs)) {
    return false;
  }

  const nowMs = options?.nowMs ?? Date.now();
  return nowMs - createdAtMs <= OWN_COMMENT_DELETE_WINDOW_MS;
}
